import { graphql } from '~/lib/graphql'

export const RestaurantIntroduction = graphql(/* GraphQL */ `
  fragment RestaurantIntroduction on Restaurant {
    catchphraseText
    introductionText
  }
`)
